import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { trainingApi, Training } from '../services/api';
import '../styles/Dashboard.css';

const iconMap: Record<string, string> = {
  calendar: '\uD83D\uDCC5',
  book: '\uD83D\uDCD6',
  chart: '\uD83D\uDCCA',
  users: '\uD83D\uDC65',
  settings: '\u2699\uFE0F',
  truck: '\uD83D\uDE9A',
  default: '\uD83D\uDCDD',
};

export function Dashboard() {
  const [trainings, setTrainings] = useState<Training[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const loadTrainings = async () => {
      try {
        const response = await trainingApi.getAll();
        if (response.success && response.trainings) {
          setTrainings(response.trainings);
        }
      } catch (err: unknown) {
        const error = err as Error;
        setError(error.message || 'Fehler beim Laden der Schulungen');
      } finally {
        setIsLoading(false);
      }
    };

    loadTrainings();
  }, []);

  const handleTileClick = (slug: string) => {
    navigate(`/training/${slug}`);
  };

  const getIcon = (iconName: string): string => {
    return iconMap[iconName] || iconMap.default;
  };

  if (isLoading) {
    return (
      <div className="dashboard-loading">
        <div className="loading-spinner"></div>
        <p>Schulungen werden geladen...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Erneut versuchen</button>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2>Willkommen im Schulungsportal</h2>
        <p>Bitte waehlen Sie eine Schulung aus</p>
      </div>

      <div className="tiles-container">
        {trainings.length === 0 ? (
          <div className="no-trainings">
            <p>Keine Schulungen verfuegbar</p>
          </div>
        ) : (
          trainings.map((training) => (
            <div
              key={training.id}
              className="tile"
              style={{ '--tile-color': training.color } as React.CSSProperties}
              onClick={() => handleTileClick(training.slug)}
            >
              <div className="tile-icon">{getIcon(training.icon)}</div>
              <h3 className="tile-title">{training.name}</h3>
              <p className="tile-description">{training.description}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Dashboard;
